import { Component, Vue, Prop } from 'vue-property-decorator';
import MiListItem from '@/components/MiListItem/MiListItem.vue';
import { Item } from '@/components//MiListItem/MiListItem.ts';

@Component<MiMenu>({
  components: {
    MiListItem,
  },
})
export default class MiMenu extends Vue {
  @Prop({ default: '' })
  protected icon!: string;

  @Prop({ default: false })
  protected openOnHover!: boolean;

  @Prop({ default: [] })
  protected items!: Item[];

  protected isOpen = false;
}
